const Features = () => {
  const features = [
    {
      icon: '🔒',
      title: 'Built-In Security',
      description: 'Your data is encrypted and password-protected directly on your device. No servers, no syncing, no leaks.',
      result: 'Complete privacy—your financial data never leaves your computer.'
    },
    {
      icon: '💵',
      title: 'One-Time Purchase',
      description: 'No subscriptions. Pay today, own forever—with lifetime access to updates.',
      result: 'Save hundreds compared to subscription apps over time.'
    },
    {
      icon: '🎯',
      title: 'Goal Tracking',
      description: 'Set your financial goals and milestones, and stay motivated as you watch your progress unfold over time.',
      result: 'Visualize your path from $10K to $1M and beyond.'
    },
    {
      icon: '🧠',
      title: 'Debt & Asset Strategy',
      description: 'Create and simulate strategies to pay off debts faster, grow your assets smarter, and build lasting financial momentum.',
      result: 'Pay off debt years earlier with smart simulations.'
    },
    {
      icon: '❔',
      title: 'What-If Simulator',
      description: 'Experiment with "what-if" scenarios to plan your path to financial freedom.',
      result: 'Test unlimited scenarios to find your optimal financial path.'
    },
    {
      icon: '📈',
      title: 'Beautiful Visualizations',
      description: 'Watch the story of your financial progress unfold in stunning, interactive, and understandable graphs.',
      result: 'Transform complex data into clear, actionable insights.'
    }
  ];

  const testimonials = [
    {
      quote: "Reminds me of Mint, but it still exists and it's privacy conscious.",
      author: "Early access user"
    },
    {
      quote: "This is so much better than my current spreadsheet method.",
      author: "Early access user"
    },
    {
      quote: "It takes what I love about Obsidian and applies it to my finances!",
      author: "Early access user"
    },
    {
      quote: "I love that it allows me to plan for the future, not just track my budget!",
      author: "Early access user"
    }
  ];

  return (
    <section className="features">
      <div className="features-container">
        <h2>Everything you need to reach your financial goals</h2>
        <p className="features-subtitle">
          Powerful tools and insights to help you plan, track, and achieve financial success
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <p className="feature-result">{feature.result}</p>
            </div>
          ))}
        </div>
        
        <div className="testimonials-divider">
          <h3>What users love about Solidly Finance</h3>
        </div>
        
        <div className="features-testimonials">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-stars" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '1.5rem', color: '#FFD700' }}>{'★★★★★'}</span>
                <span className="testimonial-rating" style={{ fontSize: '0.9rem', color: '#bbb', fontStyle: 'italic', marginLeft: 'auto' }}>5 out of 5</span>
              </div>
              <p className="testimonial-quote">"{testimonial.quote}"</p>
              <p className="testimonial-author">— {testimonial.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;